import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=4846ea2a&"
import script from "./CreateAccount.vue?vue&type=script&lang=js&"
export * from "./CreateAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports